import { render, staticRenderFns } from "./VocabularyBook.vue?vue&type=template&id=ef171fd6&scoped=true&"
import script from "./VocabularyBook.vue?vue&type=script&lang=js&"
export * from "./VocabularyBook.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/vocabulary_book.css?vue&type=style&index=0&id=ef171fd6&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/pc/vocabulary_tooltip.css?vue&type=style&index=1&id=ef171fd6&prod&scoped=true&lang=css&"
import style2 from "./VocabularyBook.vue?vue&type=style&index=2&id=ef171fd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef171fd6",
  null
  
)

export default component.exports